'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {TiledImageResource, TiledImageInfo} from './TiledImageContent.js';

const privateMap = util.createPrivateMapper();

const profileCache = {};
const loadIIIFImageInfo = function(url, successCallback, params){
  let xhr;
  const p = Object.assign({}, params, {
    url: url,
    success: function(){
      let info;
      try {
        info = JSON.parse(xhr.responseText);
      } catch (e) {
        xhr = null;
        if (params.failure) {
          params.failure(e);
        }
        return;
      }

      let prof;
      let profUrl;
      if (info && info.profile) {
        if (typeof(info.profile) == 'string') {
          profUrl = info.profile;
        } else {
          if (typeof(info.profile[1]) == 'object') {
            prof = info.profile[1];
          } else if (typeof(info.profile[0]) == 'string'){
            profUrl = info.profile[0];
          }
        }
      }
      if (profUrl) {
        let noProtocol = profUrl;
        let protocolIndex = profUrl.indexOf('://');
        if (protocolIndex > 0) {
          noProtocol = profUrl.substring(protocolIndex + 3);
        }
        if (noProtocol.indexOf('library.stanford.edu/iiif/image-api/') == 0) {
          // http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2
          prof = {
            "formats": [ "jpg" ],
            "qualities": [ "native" ]
          };
        } else if (noProtocol.indexOf('iiif.io/api/image/2/level2') == 0) {
          prof = {
            "formats": [ "jpg" ],
            "qualities": [ "default" ]
          };
        }
      }
      xhr = null;
      if (prof) {
        successCallback(info, prof);
      } else if (profUrl) {
        if (!profileCache.hasOwnProperty(profUrl)) {
          xhr = ajax({
            url: profUrl,
            success: function(){
              var prof;
              try {
                prof = JSON.parse(xhr.responseText);
              } catch (ex) {
                prof = {
                  "formats": [ "jpg" ],
                  "qualities": [ "native" ]
                };
              }
              profileCache[info.profile] = prof;
              xhr = null;
              successCallback(info, prof);
            },
            failure: function(e){
              xhr = null;
              prof = {
                "formats": [ "jpg" ],
                "qualities": [ "default" ]
              };
              profileCache[info.profile] = prof;
              successCallback(info, prof);
            }
          });
        } else {
          successCallback(info, profileCache[profUrl]);
        }
      } else {
        prof = {
          "formats": [ "jpg" ],
          "qualities": [ "default" ]
        };
        profileCache[info.profile] = prof;
        successCallback(info, profileCache[profUrl]);
      }
    }
  });
  xhr = util.ajax(p);
  return {
    abort: function(){
      if (xhr) {
        xhr.abort()
      }
    }
  }
};

export class IIIFImageResourceLoader {
  constructor(){
    const pv = privateMap(this);
    pv.cache = {}
  }

  load(source, successCallback, params){
    const pv = privateMap(this);
    let url = source.id;
    if (url.lastIndexOf('/') != url.length - 1) {
      url += '/';
    }
    const cachedResource = pv.cache[url]
    if (cachedResource) {
      successCallback(cachedResource);
      if (params && params.always) {
        params.always()
      }
      return
    }
    // return new Promise((resolve, reject) => {
    //   loadIIIFImageInfo(url + 'info.json', (imageInfo, profile) => {
    //     const resource = new IIIFImageResource(url, imageInfo, profile);
    //     resolve(resource);
    //   }, (msg) => {
    //     reject(msg);
    //   });
    // });
    return loadIIIFImageInfo(url + 'info.json', (imageInfo, profile) => {
      const resource = new IIIFImageResource(url, imageInfo, profile);
      pv.cache[url] = resource
      successCallback(resource);
    }, params);
  }
}

const vint = function(v){
  return v.toFixed(0);
};
const vintStr = function(v){
  return parseInt(v, 10) | 0;
};

class IIIFImageResource extends TiledImageResource {
  constructor(serverUrl, imageInfo, profile){
    const width = imageInfo.width;
    const height = imageInfo.height;
    const tileSize = new Point2D(256, 256);
    // const serverUrl = resource.service['@id'];
    // const size = new Point2D(width, height);
    let qualities = ['default'];
    let formats = ['jpg'];

    if (profile) {
      if (profile.qualities && profile.qualities.length) {
        qualities = profile.qualities;
      }
      if (profile.formats && profile.formats.length) {
        formats = profile.formats;
      }
    }
    const quality = qualities[0];
    const format = formats[0];
    const createTileUriFunc = function(level, x, y, levelInfo){
      const sl = Math.max(this.maxLevel - level, 0);
      const stsX = tileSize.x << sl;
      const stsY = tileSize.y << sl;
      const sx = x * stsX;
      const sy = y * stsY;
      let tw = tileSize.x;
      let th = tileSize.y;
      let sw = stsX;
      let sh = stsY;

      if (levelInfo.tileNum.x == x + 1) {
        tw = levelInfo.fractionSize.x;
        sw = levelInfo.fractionSize.x << sl;
      }
      if (levelInfo.tileNum.y == y + 1) {
        th = levelInfo.fractionSize.x;
        sh = levelInfo.fractionSize.y << sl;
      }
      const ts = (tileSize.x == tileSize.y) ? tw + ',' : tw + ',' + th;
      const src = [serverUrl, vint(sx), ',', vint(sy), ',', vint(sw), ',', vint(sh), '/', ts, '/0/', quality, '.', format].join('');
      return src;
    };
    super(new TiledImageInfo(width, height, tileSize, createTileUriFunc));
    this.qualities = qualities;
    this.formats = formats;
    // this.tiledImageInfo = new TiledImageInfo(width, height, tileSize, createTileUriFunc);
    // this.size = size;
  }

  get type(){
    return 'tiledimage';
  }



  fullImageUrl(size, quality, format){
    const w = this.size.x | 0;
    // const h = size.y | 0;
    return [serverUrl, 'full', '/', w, ',', '/0/', (quality ? quality : this.quality), '.', (format ? format : this.format)].join('');
  };
};
